import UIFetchService from '../Service/UIFetchService';
import { isEmpty, isNotEmpty, userTagsCategoryInfos, userTagsBaseFields } from '../Service/Utils';

import { Button, Col, Input, message, Row, Select, Space, Tabs } from 'antd';
import { } from '@ant-design/icons';
import React from 'react';



class UserTagsEditor extends React.Component {

    uniqueKey = 1;

    constructor() {
        super();
        this.state = {
            metadata: {},
            tag: {
                extraData: {
                    BIZ_META: {},
                    TECH_META: {},
                    QUALITY_META: {}
                }
            },
            activeTab: 'BIZ_META'
        };
    }

    render() {
        return <>
            <Row justify='center'>
                <Col flex='600px'>
                    <Tabs
                        activeKey={this.state.activeTab}
                        onChange={activeTab => this.setState({ activeTab })}
                        style={{ width: '100%' }}
                        centered
                    >
                        <Tabs.TabPane tab="业务元信息" key="BIZ_META">
                            <BizFieldsEditor
                                data={this.state.tag}
                                metadata={this.state.metadata.BIZ_META}
                                onChange={params => {
                                    const tag = { ...this.state.tag };
                                    Object.keys(params).forEach(key => {
                                        tag[key] = params[key];
                                        delete tag[key + 'Error'];
                                    });
                                    if (isNotEmpty(params.categoryClass1)) {
                                        delete tag.categoryClass2;
                                    }
                                    this.setState({ tag });
                                }}
                            />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="技术元信息" key="TECH_META">
                            <ExtFieldsEditor
                                data={this.state.tag.extraData}
                                metaKind="TECH_META"
                                metadata={this.state.metadata.TECH_META}
                                onChange={params => {
                                    const tag = { ...this.state.tag };
                                    Object.keys(params).forEach(key => {
                                        tag[key] = params[key];
                                        delete tag[key + 'Error'];
                                    });
                                    this.setState({ tag });
                                }}
                            />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="质量元信息" key="QUALITY_META">
                            <ExtFieldsEditor
                                data={this.state.tag.extraData}
                                metaKind="QUALITY_META"
                                metadata={this.state.metadata.QUALITY_META}
                                onChange={params => {
                                    const tag = { ...this.state.tag };
                                    Object.keys(params).forEach(key => {
                                        tag[key] = params[key];
                                    });
                                    this.setState({ tag });
                                }}
                            />
                        </Tabs.TabPane>
                    </Tabs>
                </Col>
            </Row>
            <Row justify='center' style={{ margin: '10px 0 0 0' }}>
                <Col>
                    <Space>
                        <Button
                            href='/user_profile/user_tags'
                        >取消</Button>
                        <Button
                            type='primary'
                            onClick={this.onSave.bind(this)}
                        >保存</Button>
                    </Space>
                </Col>
            </Row>
        </>;
    }

    async componentDidMount() {
        const metaRecords = await UIFetchService.get('/api/v1/user_tags/metadata');
        console.log(metaRecords);
        if (!metaRecords) {
            return;
        }
        const metadata = {};
        metaRecords.map(d => {
            d.key = (this.uniqueKey++).toString();
            return d;
        }).forEach(d => {
            let items = metadata[d.kind];
            if (items === undefined) {
                items = [];
                metadata[d.kind] = items;
            }
            items.push(d);
        });

        this.setState({ metadata });

        if (this.props.tagId !== undefined) {
            // Load it  
            const tag = await UIFetchService.get(`/api/v1/user_tags/tags/${this.props.tagId}`);
            this.setState({ tag });
        } else {
            const tag = {
                extraData: {
                    BIZ_META: {},
                    TECH_META: {},
                    QUALITY_META: {}
                }
            };
            for (const field of userTagsBaseFields) {
                tag[field.index] = '';
            }
            for (const field of metaRecords) {
                tag.extraData[field.kind][field.name] = '';
            }
            this.setState({ tag });
        }
    }

    async onSave() {
        if (this.check() > 0) {
            message.error('信息填写错误！');
            return;
        }

        const tag = this.state.tag;
        for (const field of userTagsBaseFields) {
            delete tag[field.index + 'Error'];
        }
        for (const key of Object.keys(this.state.metadata)) {
            for (const field of this.state.metadata[key]) {
                delete tag.extraData[key][field.name + 'Error'];
            }
        }

        if (this.props.tagId !== undefined) {
            await UIFetchService.put(`/api/v1/user_tags/tags/${this.props.tagId}`, tag);
        } else {
            tag.id = 0;
            const rs = await UIFetchService.post('/api/v1/user_tags/tags', tag);
            if (!rs) {
                return;
            }
        }
        window.location = '/user_profile/user_tags';
    }

    check() {
        let err = 0;
        const tag = this.state.tag;
        for (const field of userTagsBaseFields) {
            if (field.required) {
                if (isEmpty(tag[field.index])) {
                    tag[field.index + 'Error'] = `${field.title}不能为空`;
                    err++;
                } else {
                    delete tag[field.index + 'Error'];
                }
            }
        }
        for (const key of Object.keys(this.state.metadata)) {
            for (const field of this.state.metadata[key]) {
                if (field.required && isEmpty(tag.extraData[key][field.name])) {
                    tag.extraData[key][field.name + 'Error'] = `${field.name}不能为空`;
                    err++;
                } else {
                    delete tag.extraData[key][field.name + 'Error'];
                }
            }
        }

        this.setState({ tag });
        return err;
    }
};

class ExtFieldsEditor extends React.Component {

    render() {
        let { data, metaKind, metadata, onChange } = this.props;
        if (metadata === undefined) {
            metadata = [];
        }

        return <>
            {metadata.map(field => <TagFieldEditor
                title={field.name}
                kind={isEmpty(field.enumValues) ? 'INPUT' : 'SELECT'}
                required={field.required}
                options={isEmpty(field.enumValues) ? [] : field.enumValues.split(',').map(s => {
                    return { title: s, key: s };
                })}
                value={data[metaKind][field.name]}
                error={data[metaKind][field.name + 'Error']}
                onChange={value => {
                    const extraData = { ...data };
                    data[metaKind][field.name] = value;
                    onChange({ extraData });
                }}
            />)}
        </>;
    }
}

class BizFieldsEditor extends React.Component {

    render() {
        let { data, metadata, onChange } = this.props;
        if (metadata === undefined) {
            metadata = [];
        }
        const fields = [...userTagsBaseFields];
        const class2Field = fields.find(field => field.index === 'categoryClass2');
        if (class2Field) {
            class2Field.options = () => {
                if (isEmpty(data.categoryClass1)) {
                    return [];
                }
                const category = userTagsCategoryInfos.find(info => info.key === data.categoryClass1);
                if (!category) {
                    return [];
                }
                return category.children;
            }
        }

        return <>
            {fields.map(field => <TagFieldEditor
                title={field.title}
                kind={field.kind}
                required={field.required}
                options={field.options}
                value={data[field.index]}
                error={data[field.index + 'Error']}
                onChange={value => {
                    const params = {};
                    params[field.index] = value;
                    onChange(params);
                }}
            />)}
            {metadata.map(field => <TagFieldEditor
                title={field.name}
                kind={isEmpty(field.enumValues) ? 'INPUT' : 'SELECT'}
                required={field.required}
                options={isEmpty(field.enumValues) ? [] : field.enumValues.split(',').map(s => {
                    return { title: s, key: s };
                })}
                value={data.extraData.BIZ_META[field.name]}
                error={data.extraData.BIZ_META[field.name + 'Error']}
                onChange={value => {
                    const extraData = { ...data.extraData };
                    extraData.BIZ_META[field.name] = value;
                    onChange({ extraData });
                }}
            />)}
        </>;
    }
}

class TagFieldEditor extends React.Component {

    render() {
        let editor = <></>;
        const { required, value, kind, title, onChange, options, error } = this.props;
        switch (kind) {
            case 'INPUT':
                editor = <Input
                    value={value}
                    required={required}
                    onChange={({ target: { value } }) => onChange(value)}
                    style={{ width: '100%' }}
                />;
                break
            case 'TEXT_AREA':
                editor = <Input.TextArea
                    value={value}
                    onChange={({ target: { value } }) => onChange(value)}
                    style={{ width: '100%' }}
                    rows={4}
                />;
                break
            case 'SELECT':
                editor = <Select
                    value={value}
                    onChange={value => onChange(value)}
                    style={{ width: '100%' }}
                >
                    {(typeof options === 'function' ? options() : options).map(opt => <Select.Option value={opt.key}>
                        {opt.title}
                    </Select.Option>)}
                </Select>;
                break;
            default:
                return <></>;
        }
        return <>
            <Row style={{ margin: '10px 0 0 0' }}>
                <Col flex='120px' style={{ alignSelf: 'center', textAlign: 'right' }}>
                    {required && <span style={{ color: 'red' }}>*</span>}
                    <span>{title}：</span>
                </Col>
                <Col flex='auto'>{editor}</Col>
            </Row>
            {isNotEmpty(error) && <div style={{ textAlign: 'center' }}>
                <span style={{ color: 'red' }}>{error}</span>
            </div>}
        </>;
    }
}

export default UserTagsEditor;